import ContainerValidation from './Components/ContainerValidation';
import BodyValidation from './Components/BodyValidation';
import HeaderValidation from './Components/HeaderValidation';
import CustomCard from '../../../../components/CustomCard';
import CustomTooltip from '../../../../components/CustomTooltip';
import {
    IconAvatarTable,
    IconBuildingTable,
    IconClockTable,
    IconDeskOfficeTable,
    IconMarkerTable,
    IconScheduleTable,
    IconLogoIEntryComplete,
    PeopleTalking,
    PersonOutlinedChip,
    StarCalendarTitle, IconAddToCalendar, DetailsIconsOptions,
} from '../../../../components/buttons/IconButtons';
import CustomUserChip from '../../../../components/CustomUserChip';
import InvitationApp from './Functionality/InvitationApp';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import CustomGenericTittleIconDataChip from '../../../../components/CustomGenericTittleIconDataChip';
import {EMPTY_VALUES, getDateFormat, getFullName, getTimeFormat} from '../../../../Apis/functions';
import StatusCard from './StatusCard';
import LocationCard from './LocationCard';
import InvitationNotFound from './InvitationNotFound';
import routes from "../../../../Routes/routes";
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { STATUS_MODEL} from '../../../../enums/statusEnum';
import QrCard from "./QrCard";
import {invitationInTime} from "../Invitation/Model/Model";
import InvitationOverdue from "./InvitationOverdue";
import AccountBlocked from "./AccountBlocked";
import {Trans} from "react-i18next";
import React from "react";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Invitation = () => {

    const {
        t,
        navigate,
        guardFlowId,
        getInvitationById,
        visitorStatus, setVisitorStatus,
        visitorStatusBadge, showBadgeMessage, handleCloseBadge,
        latLng, setLatitude, setLongitude, monthDay,
        direction,
        privacyConsentDate, handleUpdatePrivacyConsent,
        chipStatusInvitation,
        getUserRestriction,
        handleAddRemoveToCalendar,
        publicGetQrCodeByUserId,
        handleDownload
    } = InvitationApp();

    const isString = typeof visitorStatusBadge?.NAME === 'string' || visitorStatusBadge?.NAME instanceof String;

    const invitation = getInvitationById?.invitation;
    const isCanceled = invitation?.visitorStatusId === STATUS_MODEL.CANCELED || parseInt(invitation?.statusId) === STATUS_MODEL.CANCELED;

    if (getInvitationById?.invitation?.visitorUserStatusId === STATUS_MODEL.ACCOUNT_LOCKED){
        return (
            <><AccountBlocked/></>
        )
    }

    return (
        <>
            {getInvitationById == null || Object.entries(getInvitationById)?.length === 0
                ? <InvitationNotFound trans={getInvitationById === null ? "loading": "invitation_not_found"}/>
                : !invitationInTime(getInvitationById?.invitation?.endDate) ?
                    <InvitationOverdue
                        title={t("this_invitation_is_no_longer_available")}
                        description={<Trans
                            i18nKey={"the_date_associated_with_this_invitation_has_passed"}
                            components={{
                                '<br/>': <br/>,
                            }}
                        />}
                    />
                    :
                    <ContainerValidation>
                        <HeaderValidation
                            showBtnBack={false}
                            headerCenter={<IconLogoIEntryComplete className={'icon-color-primary-800'} height={30} />}
                            click={()=> {
                                navigate(routes.guard.incomingInvitation)
                            }}
                        />
                        <BodyValidation
                            showBtnNext={false}
                            showBtnPrev={false}
                            showLogoFooter={false}
                            className="identity-invitation-body"
                            classWith="content-center-w-800px gap-2"
                        >

                            {(showBadgeMessage && visitorStatusBadge != null) &&
                            <CustomUserChip
                                className={visitorStatusBadge?.CLASSNAME}
                                name={isString ? t(visitorStatusBadge?.NAME) : visitorStatusBadge?.NAME}
                                Icon={visitorStatusBadge?.ICON}
                                showAvatar={true}
                                variant='large'
                                iconPosition={visitorStatusBadge?.POSITION}
                                onDelete={() => {
                                    handleCloseBadge();
                                }}
                                deleteIcon={visitorStatusBadge?.DELETE_ICON}
                                classNameText="pr-3"
                                classNameIcon={"icon-color-secondary-700"}
                            />
                            }


                            <CustomCard classes={"w-100"} classCard={'card-border-8px border-0 p-10px'} classContent={'p-0 m-0'}>
                                {/*HEADER*/}
                                {!guardFlowId &&
                                    <div className={'d-flex align-items-center mb-2'}>
                                    <div className="icons-invitation-start">
                                        <StarCalendarTitle className="w-100 h-100"/>
                                    </div>

                                    <p className={'fs-20-to-14 ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                                        {t('my_invitation')}
                                    </p>
                                    <div className='vertical-separator-shades-950'/>
                                    <CustomUserChip
                                        className={`m-0 p-0 ${chipStatusInvitation?.className ? chipStatusInvitation.className : ''}`}
                                        name={t(chipStatusInvitation?.name) || EMPTY_VALUES.DEFAULT}
                                        showAvatar={false}
                                        variant='large'
                                    />
                                </div>
                                }
                                <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                                    <div className="">
                                        <PeopleTalking className="w-100 h-100" />
                                    </div>

                                    <div className={'row'}>
                                        <div className="my-2 d-flex flex-column">
                                            <div className={'d-flex justify-content-between align-items-stretch w-100'}>
                                                <div className={'d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 h-100'}>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div><IconAvatarTable /></div>
                                                        <CustomTooltip
                                                            text={getFullName(getInvitationById?.invitation?.visitorName, getInvitationById?.invitation?.visitorLastName, getInvitationById?.invitation?.visitorSecondLastName)}
                                                            classes={"font-color-general-950 fs-14px px-2 text-ellipsis"}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                    <CustomUserChip
                                                        className='mt-0 chip-shades-300-00'
                                                        name={getInvitationById?.invitation?.visitorNumber}
                                                        Icon={PersonOutlinedChip}
                                                        showAvatar={true}
                                                        classNameText={'ibl-font-w-600'}
                                                        variant='large'
                                                        iconPosition={POSITION_MODEL.RIGHT}
                                                    />
                                                </div>
                                                {/*CALENDAR*/}
                                                <div className="custom-date-box h-100">
                                                    <div className="custom-date-box-top">{monthDay?.month || EMPTY_VALUES.DEFAULT}</div>
                                                    <div className="custom-date-box-bottom">{monthDay?.day || EMPTY_VALUES.DEFAULT}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={'border-bottom-shades-300'} />

                                    <div className={'row my-2'}>
                                        <div className={'col-12 col-md-6 mb-3'}>
                                            <CustomGenericTittleIconDataChip title={t('hosted_by')} />
                                            <div className='mt-2 d-flex align-items-center'>
                                                <PersonOutlinedChip />
                                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                                    {getFullName(getInvitationById?.invitation?.hostName, getInvitationById?.invitation?.hostLastName, getInvitationById?.invitation?.hostSecondLastName)}
                                                </p>
                                            </div>
                                        </div>

                                        <div className={'col-12 col-md-6 mb-3'}>
                                            <CustomGenericTittleIconDataChip title={t('company')} />
                                            <div className='mt-2 d-flex align-items-center'>
                                                <IconBuildingTable />
                                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                                    {getInvitationById?.company?.acronym || EMPTY_VALUES.DEFAULT}
                                                </p>
                                            </div>
                                        </div>

                                        <div className={'col-12 col-md-6'}>
                                            <CustomGenericTittleIconDataChip title={t('date_and_time')} />
                                            <div className={"mt-2"}>
                                                <div className={" d-flex align-items-center"}>
                                                    <IconScheduleTable className="icon-color-general-950" />
                                                    <p className={"font-color-general-950 fs-14px ml-2"}>
                                                        {getDateFormat(getInvitationById?.invitation?.startDate, false)}
                                                        &nbsp;{t("to").toLowerCase()}&nbsp;
                                                        {getDateFormat(getInvitationById?.invitation?.endDate, false)}
                                                    </p>
                                                </div>
                                                <div className={"d-flex align-items-center"}>
                                                    <IconClockTable className="icon-color-general-950" />
                                                    <p className={"font-color-general-950 fs-14px ml-2"}>
                                                        {getTimeFormat(getInvitationById?.invitation?.startDate)}
                                                        &nbsp;{t("to").toLowerCase()}&nbsp;
                                                        {getTimeFormat(getInvitationById?.invitation?.endDate)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>



                                        <div className={'col-12 col-md-6 mt-3 mt-md-0'}>
                                            <CustomGenericTittleIconDataChip title={t('access_zone')} />
                                            <>
                                                <div className={"mt-2"}>
                                                    {getInvitationById?.invitation?.rootFatherZoneName &&
                                                    <div className={"d-flex"}>
                                                        <IconMarkerTable className={"mr-8px mb-1"} />
                                                        <p className={"font-color-general-950 fs-14px ml-2"}>{getInvitationById?.invitation?.rootFatherZoneName}</p>
                                                    </div>
                                                    }

                                                    <div className={"d-flex"}>
                                                        {getInvitationById?.invitation?.rootFatherZoneName ? <IconDeskOfficeTable className={"mr-8px mb-1"} /> : <IconMarkerTable className={"mr-8px mb-1"} />}
                                                        <p className={"font-color-general-950 fs-14px ml-2"}>{getInvitationById?.invitation?.zoneName}</p>
                                                    </div>
                                                </div>
                                            </>
                                        </div>

                                    </div>

                                </CustomCard>

                                {!guardFlowId && (getInvitationById?.invitation?.visitorStatusId === STATUS_MODEL.ACCEPTED ||
                                    getInvitationById?.invitation?.visitorStatusId === STATUS_MODEL.CANCELED)  &&
                                <div className="mt-2">
                                    <ButtonAction
                                        id='btn_in_add_remove_to_calendar'
                                        onClick={() => {
                                            handleAddRemoveToCalendar();
                                        }}
                                        Icon={IconAddToCalendar}
                                        name={getInvitationById?.invitation?.visitorStatusId === STATUS_MODEL.ACCEPTED ? 'add_to_calendar' : 'remove_from_calendar'}
                                        className='btn-shades-700 w-100'
                                        splitName={false}
                                    />
                                </div>
                                }
                            </CustomCard>

                            <div className="w-100 px-0 d-flex flex-column flex-md-row gap-2">
                                <div className="w-100" style={ guardFlowId && (isCanceled) ? {} : { flexBasis: '0', flexGrow: 8 }}>
                                    <CustomCard classes="w-100 h-100" classCard="card-border-8px border-0 p-10px" classContent="p-0">
                                        <StatusCard
                                            classes={'minh-235px'}
                                            content={{
                                                ...visitorStatus,
                                                HEADER: visitorStatus.HEADER({
                                                    setVisitorStatus,
                                                    id: getInvitationById?.invitation?.id || null,
                                                    guardFlowId,
                                                }),
                                                BODY: visitorStatus.BODY({
                                                    setVisitorStatus,
                                                    id: getInvitationById?.invitation?.id || null,
                                                    privacyConsentDate,
                                                    guardFlowId,
                                                    handleUpdatePrivacyConsent,
                                                    statusId:getInvitationById?.invitation?.statusId,
                                                    identityValidation:getInvitationById?.invitation?.identityValidation,
                                                    getUserRestriction:getUserRestriction
                                                }),
                                            }}
                                        />
                                    </CustomCard>
                                </div>

                                { !guardFlowId && !isCanceled &&
                                <div className="w-100" style={{flexBasis: '0', flexGrow: 4}}>
                                    <CustomCard classes="w-100 h-100" classCard="card-border-8px border-0 p-10px"
                                                classContent="p-0">
                                        {latLng?.length >= 2 &&
                                        <LocationCard
                                            t={t}
                                            latlng={latLng}
                                            setLatitude={setLatitude}
                                            setLongitude={setLongitude}
                                            mainZone={getInvitationById?.invitation?.rootFatherZoneName || ''}
                                            subZone={getInvitationById?.invitation?.zoneName || ''}
                                            location={<>{t('open_maps')} <DetailsIconsOptions className={'icon-color-secondary-500'} width={16} height={16} /></>}
                                            classNameMap="h-125px w-100"
                                            classNameLocation={'font-color-secondary-500 ibl-font-w-500 fs-14px'}
                                            disabled={true}
                                        />
                                        }
                                    </CustomCard>
                                </div>
                                }
                            </div>

                            { !isCanceled &&
                                publicGetQrCodeByUserId &&
                                    <CustomCard classes="w-100 h-100 mb-4" classCard="card-border-8px border-0 p-10px"  classContent="p-0">
                                        <QrCard
                                            t={t}
                                            data={publicGetQrCodeByUserId}
                                            getInvitationById={getInvitationById}
                                            handleDownload={handleDownload}
                                        />
                                    </CustomCard>
                            }
                        </BodyValidation>
                    </ContainerValidation>
            }
        </>
    )
}

export default Invitation
